module.exports = __webpack_public_path__ + "static/teaser-mobile-1-4467eb48da59c104ca1799eeba4ba776.png";